import "content/adminEditors/ContentAdminEditor";
import "content/adminEditors/ContentAdminEditorFiles";
import "content/adminEditors/ContentAdminEditorGallery";
import "content/adminEditors/ContentAdminEditorImage";
import "content/adminEditors/ContentAdminEditorTags";
import "content/adminEditors/ContentAdminEditorText";
import "content/adminEditors/ContentAdminEditorVideo";
import "content/adminEditors/ContentAdminEditorWysiwyg";
import "content/adminEditors/ContentAdminEditorCategory";
import "content/adminEditors/ContentAdminEditorDate";
import "content/adminEditors/ContentAdminEditorNumber";
import "content/adminEditors/ContentAdminEditorDateTime";
import "content/adminEditors/categories/AdminCategoriesEditor";

import "content/modalEditors/CategoriesEditor";

import ContentPost from "content/ContentPost";

import $ from "jquery";

if (window.User) {
    $(function () {
        $("[data-content-type][data-content-post]").each(function () {
            ContentPost.process($(this));
        });
    });
}
